import { makeStyles } from "@material-ui/core";

const styles = makeStyles(() => ({
  root: {
    width: 300,
    "& > div": {
      marginTop: 40,
      height: "calc(100vh - 40px)",
    },
  },
}));

export default styles;
